import React from 'react';
import { Check } from 'lucide-react';
import { AppStep } from '../types';

interface Props {
  currentStep: AppStep;
}

const STEPS = [
  { num: 1, label: 'Personas a consultar' },
  { num: 2, label: 'Tus datos' },
  { num: 3, label: 'Pago' },
];

const TRUST_LOGOS = [
  { key: 'wompi', src: '/logos/wompi.svg', alt: 'Wompi - Pagos seguros', w: 80 },
];

export default function Header({ currentStep }: Props) {
  return (
    <header className="sticky top-0 z-50 w-full" style={{ backgroundColor: 'var(--header-bg)', backdropFilter: 'blur(20px)', borderBottom: '1px solid var(--border-color)' }}>
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        {/* Logo */}
        <div className="flex-shrink-0">
          <img src="/logo.png" alt="Rastreador de Bienes" className="h-10 w-auto object-contain" />
        </div>

        {/* Step Progress - center */}
        <div className="flex-1 max-w-lg hidden sm:flex items-center justify-center">
          <div className="flex items-center w-full">
            {STEPS.map((step, i) => {
              const completed = currentStep > step.num;
              const active = currentStep === step.num;
              return (
                <React.Fragment key={step.num}>
                  <div className="flex flex-col items-center">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300 ${
                      completed ? 'bg-[#10B981] text-white' :
                      active ? 'bg-[#2563EB] text-white shadow-lg shadow-blue-500/30' :
                      'bg-white border-2 border-slate-200 text-[#64748B]'
                    }`}>
                      {completed ? <Check size={14} /> : step.num}
                    </div>
                    <span className={`text-xs mt-1 font-medium whitespace-nowrap ${active ? 'text-[#2563EB]' : completed ? 'text-[#10B981]' : 'text-[#64748B]'}`}>
                      {step.label}
                    </span>
                  </div>
                  {i < STEPS.length - 1 && (
                    <div className="flex-1 h-0.5 mx-2 mb-4 rounded-full transition-all duration-500" style={{ backgroundColor: currentStep > step.num ? '#10B981' : '#E2E8F0' }} />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>

        {/* Wompi logo only */}
        <div className="flex-shrink-0 hidden lg:flex items-center">
          <img src="/logos/wompi.svg" alt="Wompi - Pagos seguros" title="Pagos procesados por Wompi" className="object-contain opacity-80 hover:opacity-100 transition-opacity" style={{ width: 80, height: 28 }} />
        </div>
      </div>

      {/* Mobile step progress */}
      <div className="sm:hidden px-4 pb-2">
        <div className="flex items-center justify-center gap-3">
          {STEPS.map((step, i) => {
            const completed = currentStep > step.num;
            const active = currentStep === step.num;
            return (
              <React.Fragment key={step.num}>
                <div className={`flex items-center gap-1 text-xs font-medium ${active ? 'text-[#2563EB]' : completed ? 'text-[#10B981]' : 'text-[#94A3B8]'}`}>
                  <span className={`w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold ${completed ? 'bg-[#10B981] text-white' : active ? 'bg-[#2563EB] text-white' : 'border border-slate-300 text-[#94A3B8]'}`}>
                    {completed ? <Check size={10} /> : step.num}
                  </span>
                  <span>{step.label}</span>
                </div>
                {i < STEPS.length - 1 && <div className="w-4 h-px" style={{ backgroundColor: currentStep > step.num ? '#10B981' : '#E2E8F0' }} />}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </header>
  );
}
